import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class SearchAnimation {
  constructor(searchModal) {
    this.searchModal = searchModal
    this.searchButton = document.querySelector(".js-search");
    this.closeButton = document.querySelector(".js-search-cancel")
    this.siteFooter = document.querySelector('.js-site-footer');
    this.animate(this.searchModal, this.siteFooter);
  }

  animate(modal, footer) {
    if(!this.searchButton) {
      return
    }

    // open timeline
    var searchTl = gsap.timeline({  repeatRefresh: true, paused: true, defaults: { duration: 1, ease: "power1.inOut"},
    });
    searchTl.set(".search-modal__content", {opacity: 0});
    searchTl.set(".search-modal__svg-overlays", {opacity: 1});
    searchTl.from(".search-modal__svg-overlay", {stagger: .25, y: -200, bottom: "calc(100%"});
    searchTl.set(".search-modal__content", {opacity: 1});
    searchTl.from(".search-modal__svg-overlay-last", {bottom: "100%", y: -200, duration: 2}, ">-.4");
    searchTl.set(".search-modal__svg-overlays", {backgroundColor: "transparent"}, "<+1");
    searchTl.set(".search-modal__svg-overlay", {opacity: 0}, "<");
    searchTl.set(".search-modal__svg-overlays", {opacity: 0}, "<+2");
    searchTl.set(".search-modal__svg-overlays-cancel", {opacity: 1});

    // close timeline
    var searchCloseTl = gsap.timeline({ repeatRefresh: true, paused: true, defaults: { duration: 1, ease: "power1.inOut"},
    });
    searchCloseTl.set(".search-modal__content", {opacity: 1});

    searchCloseTl.set(".search-modal", {opacity: 1, display: "block", visibility: "visible"})
    searchCloseTl.set(".search-modal__svg-overlays-cancel", {opacity: 1}),
    searchCloseTl.fromTo(".search-modal__content", { y: 0 }, { y: "-110%" });
    searchCloseTl.fromTo(".search-modal__svg-overlay-cancel", { y: 0 }, { stagger: .25, y: "-110%", onComplete : function() {
      modal.classList.remove('--open');
      footer.classList.remove('--search-modal-open');
    }}, "<");
    searchCloseTl.to(".search-modal__content", { y: 0, onComplete : function() {
      gsap.to([".search-modal__content",
          ".search-modal__svg-overlay",
          ".search-modal__svg-overlay-last",
          ".search-modal__svg-overlays",
          ".search-modal__svg-overlays-cancel",
          ".search-modal__svg-overlay-cancel"],
          {clearProps:true});
    }
    }, ">");

    this.searchButton.addEventListener("click", () => {
      searchTl.restart().timeScale(1);
    });
    this.closeButton.addEventListener("click", () => {
      searchCloseTl.restart();
      // searchTl.set([".search-modal__content",
      //   ".search-modal__svg-overlay",
      //   ".search-modal__svg-overlay-last",
      //   ".search-modal__svg-overlays"],
      //   {clearProps:true});
      searchTl.reverse().timeScale(3);
    });
    // listener for closing modal w/ Escape key
    document.addEventListener('keydown', (event) => handleKeydown(event));

    function handleKeydown(event) {
      if (event.key === 'Escape' && modal.classList.contains('--open')) {
        searchCloseTl.restart();
        searchTl.reverse().timeScale(3);
      }
    }
  }
}
